module.exports = __webpack_public_path__ + "assets/quantum-metric.2a5eee0c.svg";